import { useTranslation } from "react-i18next"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import toastr from "toastr"

interface UseRemoveDiscountMutationParams {
  orderUuid: string
  deviceId: string
}

export const useRemoveDiscountMutation = ({
  orderUuid,
  deviceId
}: UseRemoveDiscountMutationParams) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async () => {
      return axios.patch(`/api/registration/order/${orderUuid}/?device_id=${deviceId}`, {
        discount_code: null,
      })
    },
    onSuccess: () => {
      // Invalidate and refetch order data
      queryClient.invalidateQueries({ queryKey: ["order", orderUuid] })
      toastr.success(t("discount.removed_successfully"))
    },
    onError: (error: any) => {
      const message = String(
        error.response?.data?.message || "Failed to remove discount"
      )
      toastr.error(message, t("discount.remove_error"))
    },
  })
}